import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "textarea", "form" ]

  connect() {
    this.boundHandleKeydown = this.handleKeydown.bind(this);
    this.textareaTarget.addEventListener('keydown', this.boundHandleKeydown);

    const length = this.textareaTarget.value.length;
    this.textareaTarget.setSelectionRange(length, length);
    
    // Prevent form submission on Enter key
    this.formTarget.addEventListener('keypress', (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
      }
    });
  }

  disconnect() {
    if (this.textareaTarget) {
      this.textareaTarget.removeEventListener('keydown', this.boundHandleKeydown);
    }
    this.boundHandleKeydown = null;
  }

  handleKeydown(event) {
    // Only handle Enter key events
    if (event.key !== 'Enter') return;
    
    if (event.shiftKey) {
      // Let the default behavior happen for Shift+Enter (new line)
      return;
    }
    
    // Prevent empty submissions
    if (!this.textareaTarget.value.trim()) {
      event.preventDefault();
      return;
    }
    
    // Handle regular Enter (form submission)
    event.preventDefault(); // Prevent default Enter behavior
    if (this.hasFormTarget) {
      // Submits via Turbo (same as clicking the submit button would)
      this.formTarget.requestSubmit();
    } else {
      console.error("Comment form target not found.");
    }
  }
}